import { dateParts, zonedWallTimeToUtc } from "./zoned-time";
export function computeNextAwardAt({
  awardTime,
  timeZone,
  now,
}: {
  readonly awardTime: string;
  readonly timeZone: string;
  readonly now: Date;
}): Date | null {
  const match = /^(\d{2}):(\d{2})$/.exec(awardTime);

  if (!match) return null;

  const hour = Number(match[1]);
  const minute = Number(match[2]);

  if (hour > 23 || minute > 59) return null;

  try {
    const today = dateParts({
      at: now,
      timeZone,
    });
    let candidate = zonedWallTimeToUtc({
      year: today.y,
      month: today.m,
      day: today.d,
      hour,
      minute,
      timeZone,
    });

    if (candidate <= now.getTime()) {
      // Roll forward a wall-clock day, then re-derive Y/M/D in the target
      // zone (via Intl) rather than incrementing `d` by hand, so month/year
      // rollovers are never wrong.
      const tomorrow = dateParts({
        at: new Date(candidate + 24 * 3600000),
        timeZone,
      });
      candidate = zonedWallTimeToUtc({
        year: tomorrow.y,
        month: tomorrow.m,
        day: tomorrow.d,
        hour,
        minute,
        timeZone,
      });
    }

    return new Date(candidate);
  } catch {
    return null; // an invalid IANA zone name throws from Intl
  }
}
